module.exports = __webpack_public_path__ + "img/fixtures-background.da80f944.jpg";